module.exports = __webpack_public_path__ + "static/media/img80.2453423f.jpg";